module.exports = window.wp.uploadMedia;